<template>
  <div class="row">
    <div class="col-md-3 col-sm-6 col-12">
      <div class="info-box bg-warning">
        <span class="info-box-icon"><i class="far fa-calendar-alt"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">Tested PWIDs</span>
          <div class="info-box-number">
              {{ Number(testedPWIDs).toLocaleString()  }} -
              <span class="float-right">13,500</span></div>

          <div class="progress">
            <!-- 26,0000 -->
            <div class="progress-bar"
            v-bind:style="{ width: testedPWIDsPercentage + '%' }"
            ></div>
          </div>
          <span class="progress-description">
            {{ testedPWIDsPercentage }}% achieved
          </span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-md-3 col-sm-6 col-12">
      <div class="info-box bg-success">
        <span class="info-box-icon"><i class="far fa-thumbs-up"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">Tested spouses</span>
          <div class="info-box-number">{{ Number(testedSpouses).toLocaleString()  }} -
              <span class="float-right">2,592</span></div>

          <div class="progress">
            <div class="progress-bar"
            v-bind:style="{ width: testedSpousesPercentage + '%' }"
            ></div>
          </div>
          <span class="progress-description">
            {{ testedSpousesPercentage }}% achieved
          </span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-md-3 col-sm-6 col-12">
      <div class="info-box bg-cyan">
        <span class="info-box-icon"><i class="far fa-calendar-alt"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">Tested follow up PWID</span>
          <span class="info-box-number">{{ Number(testedFollowupPWID).toLocaleString()  }}</span>

          <!-- <div class="progress">
                            <div class="progress-bar" style="width: 30%"></div>
                        </div> -->
          <span class="progress-description">
            <!-- 70% Increase in 30 Days -->
          </span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
    <div class="col-md-3 col-sm-6 col-12">
      <div class="info-box bg-danger">
        <span class="info-box-icon"><i class="fas fa-vial"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">Tested new PWID</span>
          <span class="info-box-number">{{ Number(testedNewPWID).toLocaleString()  }}</span>

          <!-- <div class="progress">
                            <div class="progress-bar" style="width: 70%"></div>
                        </div> -->
          <span class="progress-description">
            <!-- 70% Increase in 30 Days -->
          </span>
        </div>
        <!-- /.info-box-content -->
      </div>
      <!-- /.info-box -->
    </div>
    <!-- /.col -->
  </div>
</template>

<script>
export default {
  name: "htc-indicators",
  data() {
    return {
      indicators: null,
      testedPWIDs: null,
      testedSpouses: null,
      testedFollowupPWID: null,
      testedNewPWID: null,
      testedPWIDsPercentage: 0,
      testedSpousesPercentage: 0,
      exchangeRatePercentage: 0,
      syringePerPersonPercentage: 0,
    };
  },
  methods: {
    async callNsepIndicators() {
      await axios
        .get("htsIndicators")
        .then((response) => {
          if (response.status == 200) {
            this.indicators = response.data;
            this.testedPWIDs = this.indicators.TestedPWIDs;
            this.testedSpouses = this.indicators.TestedSpouses;
            this.testedFollowupPWID = this.indicators.TestedFollowupPWID;
            this.testedNewPWID = this.indicators.TestedNewPWID;

            // percentage calculation
            this.testedPWIDsPercentage = parseFloat(
              (parseInt(this.testedPWIDs) / 13500) * 100
            ).toFixed(0);
            this.testedSpousesPercentage = parseFloat(
              (parseInt(this.testedSpouses) / 2592) * 100
            ).toFixed(0);
            this.exchangeRatePercentage = parseFloat(
              parseFloat(this.exchangeRate) * 100
            ).toFixed(0);
            this.syringePerPersonPercentage = parseFloat(
              (parseInt(this.syringePerPerson) / 250) * 100
            ).toFixed(0);
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
  },
  mounted() {
      this.callNsepIndicators()
  },
};
</script>

<style lang="scss" scoped>
</style>
